import { entity } from 'jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'colleges' })
export class College extends HierarchyNode {}
